module.exports = __webpack_public_path__ + "img/drew-hays-agGIKYs4mYs-unsplash.e32312d8.png";